import { memo } from 'react'
import { Text, TextAreaInput } from 'common-components'
import CrownGradient from 'assets/svgr-icons/Crown_gradient.svg'
import WarningIcon from 'assets/svgr-icons/Warning.svg'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import PlayControl from './PlayControl'
import { useSpeech } from './useSpeech'
import * as Styled from './styled'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from 'hooks/useResponsive'

const SpeechSection: React.FC = () => {
  const {
    text,
    onChangeText,
    maxLength,
    showUpgradeLink,
    showLanguageMismatchWarning,
    playState,
    progress,
    isPlayDisabled,
    onTogglePlay,
    onUpgradeClick
  } = useSpeech()

  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  return (
    <Styled.SpeechSectionContainer>
      <Text type="subtitle" color="secondaryDark">
        {translate(T.SPEECH_LABEL)}
      </Text>

      <Styled.SpeechInputBox>
        <TextAreaInput
          value={text}
          onChange={onChangeText}
          maxLength={maxLength}
          placeholder={translate(T.SPEECH_PLACEHOLDER)}
          hasBorderStyles={false}
          minHeight={isTablet ? 98 : 114}
          maxHeight={isTablet ? 98 : 114}
        />

        <Styled.Footer>
          <PlayControl
            playState={playState}
            progress={progress}
            disabled={isPlayDisabled}
            onClick={onTogglePlay}
          />
          <Styled.Counter>{`${text.length} / ${maxLength}`}</Styled.Counter>
        </Styled.Footer>
      </Styled.SpeechInputBox>

      {showLanguageMismatchWarning && (
        <Styled.WarningRow>
          <WarningIcon />
          <Styled.WarningText>
            {translate(T.TTS_TRIAL_LANGUAGE_MISMATCH_WARNING)}
          </Styled.WarningText>
        </Styled.WarningRow>
      )}

      {showUpgradeLink && (
        <Styled.UpgradeLink onClick={onUpgradeClick}>
          <CrownGradient />
          <Styled.UpgradeText>
            {translate(T.UPGRADE_FOR_LONGER_VIDEOS)}
          </Styled.UpgradeText>
        </Styled.UpgradeLink>
      )}
    </Styled.SpeechSectionContainer>
  )
}

export default memo(SpeechSection)
